import { apiCall } from "../../utils/servicesUtils"

const BASE_URL = process.env.REACT_APP_BACKEND_URL

/**
 * Shared helper — appends brand-guidelines params to a FormData object.
 * Used by paintingApi, videoApi, and generationApi to avoid repeating this block.
 */
export const appendBrandGuidelinesParams = (
    formData: FormData,
    useBrandGuidelines?: boolean,
    excludedAssetIds?: string[]
): void => {
    formData.append('use_brand_guidelines', useBrandGuidelines ? 'true' : 'false')
    if (excludedAssetIds && excludedAssetIds.length > 0) {
        formData.append('excluded_asset_ids', JSON.stringify(excludedAssetIds))
    }
}

export const apiGetBrandGuidelines = (
    projectId: string
): Promise<BrandGuidelines> => {
    const urlFetch = `${BASE_URL}/api/projects/${projectId}/brand-guidelines`
    return apiCall(urlFetch, 'GET', null)
}

export const apiPutBrandGuidelines = (
    projectId: string,
    brand: BrandGuidelinesUpsert
) => {
    const urlFetch = `${BASE_URL}/api/projects/${projectId}/brand-guidelines`
    return apiCall(urlFetch, 'PUT', JSON.stringify(brand))
}

export const apiPostBrandGuidelinesCrawl = (
    projectId: string,
    urlToCrawl: string
): Promise<BrandGuidelinesCrawlResponse> => {
    const urlFetch = `${BASE_URL}/api/projects/${projectId}/brand-guidelines:auto`
    return apiCall(urlFetch, 'POST', JSON.stringify({ website_url: urlToCrawl }))
}

export const apiCreateBrandAsset = (
    projectId: string,
    formData: FormData
): Promise<BrandAsset> => {
    const urlFetch = `${BASE_URL}/api/projects/${projectId}/brand-guidelines/assets`
    return apiCall(urlFetch, 'POST', formData, true)
}

export const apiUpdateBrandAsset = (
    projectId: string,
    assetId: string,
    formData: FormData
): Promise<BrandAsset> => {
    const urlFetch = `${BASE_URL}/api/projects/${projectId}/brand-guidelines/assets/${assetId}`
    return apiCall(urlFetch, 'PUT', formData, true)
}

export const apiDeleteBrandAsset = (
    projectId: string,
    assetId: string
): Promise<void> => {
    const urlFetch = `${BASE_URL}/api/projects/${projectId}/brand-guidelines/assets/${assetId}`
    return apiCall(urlFetch, 'DELETE', null)
}

export const apiPostBrandTrain = async (
    projectId: string
): Promise<TrainingResponse> => {
    const urlFetch = `${BASE_URL}/api/projects/${projectId}/brand-guidelines:train`
    try {
        return await apiCall(urlFetch, 'POST', JSON.stringify({}), false, true)
    } catch (err: any) {
        // apiCall with fullResponse=true throws the raw Response for 4xx.
        // Re-throw as a plain object so callers can branch on error code.
        if (err && typeof err.json === 'function') {
            const body = await err.json()
            throw body  // { error: "no_trainable_assets", detail: "..." }
        }
        throw err
    }
}
